module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAANZJREFUaEPtlzsOgDAMQ+nC/Rg5ISP3YymqxEhbiF0hpMfchNjP4ZOmn1/p5/NPCPiaIAQgIDpAhEQD5XIIyBaKDSAgGiiXQ0C2UGwwlECe173Ml45tEeeslo8WkC8Bw+4zrHEZPM8rAnrRsxCoZb1GwLkbLgG3UWkIsEULAa1lhUBvg8s75sGZ7pG3TjsfrwhgB7oBbR8gQkSICIkOXBG6/XFpfOTZfnQsS2zwINwCAWHrTIUQMBkZbgOBsHWmQgiYjAy3gUDYOlMhBExGhttAIGydqfAEus24MV9oZWoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/courselist/live.png
// module id = CGG+
// module chunks = 23